/**
 * The BCP-47 tag to hand to `Intl`, which is **not** the storefront's locale code.
 *
 * `eu` is the English euro-area storefront. `eu` is also the ISO 639-1 code for
 * Basque, and ICU resolves it natively rather than falling back — measured:
 * `new Intl.NumberFormat('eu').resolvedOptions().locale === 'eu'`. So handing
 * `useI18n().locale` to a formatter gives Basque rules on a fully English page:
 * `Intl.ListFormat` joins with "eta", `Intl.NumberFormat` writes `182,5` where
 * the page means `182.5`.
 *
 * Every locale object already carries the language it is actually written in
 * (`eu.language === 'en'`), and that is what `Intl` must be given. `eu` is the
 * only shipped code where the two differ, which is exactly why the bug is easy
 * to reintroduce — every other locale works by coincidence.
 *
 * Use this wherever a value reaches an `Intl` constructor. Keep using
 * `useI18n().locale` for message lookup and for building URLs, both of which are
 * keyed on the storefront code rather than the language.
 */
export function useIntlLocale() {
  const localeObject = useLocaleObject()
  return computed(() => localeObject.value?.language ?? 'en')
}
